import poolAbi from 'abis/AcornReferralsVault.json'
import BigNumber from 'bignumber.js'
import { REFERRALS_VAULT_ADDRESS } from 'constants/addresses'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import useRefresh from 'hooks/useRefresh'
import { useCallback, useEffect, useState } from 'react'
import { BIG_ZERO } from 'utils/bigNumber'
import Multicall from 'utils/multicall'
import { isChainAllowed } from 'utils/switchChain'

import { WalletDetails } from '../types'

const useGetWalletPoolData = (): WalletDetails => {
  const { account, chainId, connector } = useActiveWeb3React()
  const { slowRefresh } = useRefresh()
  const [state, setState] = useState({
    points: BIG_ZERO,
    earned: BIG_ZERO,
    onPool: false,
  })

  const chainAllowed = chainId && isChainAllowed(connector, chainId)

  const address = REFERRALS_VAULT_ADDRESS[chainAllowed ? chainId : 137]

  const fetchWalletData = useCallback(async () => {
    const PoolCalls = [
      { address, name: 'getWalletInfo', params: [account] },
      { address, name: 'getPendingBal', params: [account] },
      { address, name: 'isInPool', params: [account] },
    ]

    const [info, points, isInPool] = await Multicall(chainAllowed ? chainId : 137, poolAbi, PoolCalls)

    setState((prev) => ({
      ...prev,
      points: new BigNumber(info[0].toString() ?? '0'),
      earned: new BigNumber(points[0].toString() ?? '0'),
      onPool: Boolean(isInPool[0]),
    }))
  }, [account, address, chainAllowed, chainId])

  useEffect(() => {
    if (account) {
      fetchWalletData()
    }
  }, [account, fetchWalletData, slowRefresh])

  return { ...state, fetchWalletData }
}

export default useGetWalletPoolData
